export const logView = (hotelContent) => {
  window.addEventListener('load', () => {
    if (typeof exponea !== 'undefined') {
      // eslint-disable-next-line no-undef
      exponea.track('view_item', {
        wvid: hotelContent?.meta?.wvId,
        travel_product_brand: hotelContent.productInfo?.productName?.replace(
          /\s/g,
          '',
        ),
      });
    }
  });
};
